module.exports = __webpack_public_path__ + "img/natudrin-depoimento-5.e2c0b388.jpg";